import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Navbar.css";

export const Navbar: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const history = useHistory();

  const handleExternalNavigation = (url: string) => {
    window.location.href = url;
  };

  return (
    <div className="header-announcement-bar-wrapper">
      <a href="#page" className="header-skip-link">
        Skip to Content
      </a>

      <div className="header-inner container--fluid">
        <div className="header-background theme-bg--primary"></div>
        <div className="header-border-bottom"></div>

        <div className="header-display-desktop" data-content-field="site-title">
          <div className="header-title-nav-wrapper">
            <div
              className="header-title header-title--use-mobile-logo"
              data-animation-role="header-element"
            >
              <div className="header-title-logo">
                <button
                  onClick={() =>
                    handleExternalNavigation(
                      "https://www.cpadministration.co.nz/"
                    )
                  }
                  data-animation-role="header-element"
                >
                  <picture>
                    <img
                      {...({
                        elementTiming: "nbf-header-logo-desktop",
                        fetchPriority: "high",
                        decoding: "async",
                        "data-loader": "raw",
                      } as any)}
                      src="/parkchek-logo.png"
                      alt="CP Administration"
                      style={{ display: "block" }}
                      loading="eager"
                    />
                  </picture>
                </button>
              </div>

              <div className="header-mobile-logo">
                <button
                  onClick={() =>
                    handleExternalNavigation(
                      "https://www.cpadministration.co.nz/"
                    )
                  }
                  data-animation-role="header-element"
                >
                  <picture>
                    <source
                      media="only screen and (pointer: coarse) and (max-width: 1024px), screen and (max-width: 799px)"
                      srcSet="/parkchek-logo.png"
                    />
                    <source
                      media="only screen and (pointer: coarse) and (min-width: 1025px), screen and (min-width: 800px)"
                      srcSet="/parkchek-logo.png"
                    />
                    <img
                      {...({
                        elementTiming: "nbf-header-logo-desktop",
                        fetchPriority: "high",
                        decoding: "async",
                        "data-loader": "raw",
                      } as any)}
                      src="/parkchek-logo.png"
                      alt="CP Administration"
                      style={{ display: "block" }}
                      loading="eager"
                    />
                  </picture>
                </button>
              </div>
            </div>

            <nav className="header-nav">
              <div className="header-nav-wrapper">
                <button
                  onClick={() =>
                    handleExternalNavigation(
                      "https://www.cpadministration.co.nz/"
                    )
                  }
                  className="header-nav-item"
                >
                  Home
                </button>
              </div>
            </nav>
          </div>

          <div className="header-actions header-actions--right">
            <div
              className="header-actions-action header-actions-action--cta"
              data-animation-role="header-element"
            >
              <button
                className="btn btn--border theme-btn--primary-inverse sqs-button-element--primary"
                onClick={() => history.push("/")}
              >
                Pay Parking Breach
              </button>
            </div>
          </div>
        </div>

        <div className="header-display-mobile" data-content-field="site-title">
          <div className="header-title-nav-wrapper">
            <div
              className="header-title header-title--use-mobile-logo"
              data-animation-role="header-element"
            >
              <div className="header-mobile-logo">
                <button
                  onClick={() =>
                    handleExternalNavigation(
                      "https://www.cpadministration.co.nz/"
                    )
                  }
                  data-animation-role="header-element"
                >
                  <picture>
                    <source
                      media="only screen and (pointer: coarse) and (max-width: 1024px), screen and (max-width: 799px)"
                      srcSet="/parkchek-logo.png"
                    />
                    <source
                      media="only screen and (pointer: coarse) and (min-width: 1025px), screen and (min-width: 800px)"
                      srcSet="/parkchek-logo.png"
                    />
                    <img
                      {...({
                        elementTiming: "nbf-header-logo-mobile",
                        fetchPriority: "high",
                        decoding: "async",
                        "data-loader": "raw",
                      } as any)}
                      src="/parkchek-logo.png"
                      alt="CP Administration"
                      style={{ display: "block" }}
                      loading="eager"
                    />
                  </picture>
                </button>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="header-actions header-actions--right">
            <button
              className="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span className={`menu-icon ${mobileMenuOpen ? "open" : ""}`}>
                <span></span>

                <span></span>
              </span>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div
            className="mobile-menu-overlay"
            onClick={() => setMobileMenuOpen(false)}
          >
            <nav className="mobile-nav" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={() => {
                  handleExternalNavigation(
                    "https://www.cpadministration.co.nz/"
                  );
                  setMobileMenuOpen(false);
                }}
                className="mobile-nav-item"
              >
                Home
              </button>
              <button
                className="mobile-nav-item mobile-nav-cta"
                onClick={() => {
                  history.push("/");
                  setMobileMenuOpen(false);
                }}
              >
                Pay Parking Breach
              </button>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
};
